<template>

    <body style="padding: 0 20px; margin: 0px">

        <div id="box-phone"
             style="display: block;">

            <div style="text-align: center; margin-top: 4vh">

                <svg class="icon"
                     style="height: 60px; vertical-align: middle; fill: currentColor; overflow: hidden;"
                     viewBox="0 0 2852 1024"
                     version="1.1"
                     xmlns="http://www.w3.org/2000/svg"
                     p-id="4154">
                    <path d="M2733.20131 699.24583l-44.031985 97.828537-45.458269-97.828537h-44.031984l68.169118 135.241095v93.513109h41.215985v-93.513109l68.169119-135.241095h-44.031984z m-326.729027 58.989693l31.268561 94.939395h-63.926835l32.658274-94.939395z m41.215986 123.721099l15.615994 46.043412h42.605699L2422.124849 699.24583h-32.694845l-83.785113 228.754204h42.605699l15.615994-46.043412h83.821685z m-316.781601-73.362259h-45.45827v-79.140544h45.45827c22.74742 0 35.510844 20.114279 35.510844 38.838844 1.462857 20.114279-11.337139 40.3017-35.474273 40.3017z m2.85257-109.348533h-88.063969v228.754204h41.179414v-87.771397h46.884555c44.031984 0 75.300545-28.781704 75.300544-70.509689 0-41.691414-31.26856-70.473118-75.337115-70.473118z m-295.497037 228.754204h41.215985V699.24583h-41.179414v228.754204zM1551.359446 699.24583v228.754204h137.801094v-31.634274h-96.62168v-197.11993H1551.359446z m-232.959917 58.989693l31.231989 94.939395h-63.890263l32.658274-94.939395z m41.179414 123.721099l15.652566 46.043412h42.605699l-83.821684-228.754204h-32.658274l-83.821685 228.754204h42.605699l15.652566-46.043412h83.785113z m288.365611-630.16206h-174.701652V188.489441h203.117642V149.577455h-203.117642V69.047198h-90.916539a18.907422 18.907422 0 0 0-18.468564 18.724565V149.577455h-201.727928v38.875415h201.727928v63.268549h-170.459368v38.875414h339.49245s-18.468565 73.36226-112.237674 153.96566c-83.785113-63.341692-110.811389-115.126816-110.811389-115.126816h-90.879968c36.93713 64.731405 89.490254 116.553101 144.895949 156.818229-51.16341 34.523416-119.332529 66.194262-205.970213 93.51311v47.506269s133.485667-25.892562 262.765621-102.143964c129.279954 76.251401 259.949621 102.143964 259.949621 102.143964v-44.617127a1120.877314 1120.877314 0 0 1-201.691356-96.402252c76.690258-57.526837 142.043378-133.778238 169.033082-234.495916z m568.210083-175.542795h-90.916539v96.402251h-224.438777v38.838844h224.438777v345.307305c0 7.204569-7.094855 14.372566-14.226281 14.372566h-46.847983v40.3017h117.906244c18.431993-1.462857 34.084559-17.261708 34.084559-35.986273V211.492862h36.93713V172.654018h-36.93713V76.251767z m-191.780503 199.9725c-2.85257-7.167997-9.947425-11.483424-18.468565-11.483424h-75.263973l59.611407 188.452504h89.526826l-55.405695-176.96908z m792.64886 328.045597l-31.26856-109.348532c-1.426285-7.167997-8.52114-11.483424-15.615995-11.483425h-85.211398l24.137134 83.419399h-99.47425v-162.559942h196.059359V365.458521h-196.022787V289.20712h196.022787V250.331705h-490.056968v38.875415h196.022787v76.251401h-196.022787v38.838843h196.022787V566.857306h-196.022787v38.875415l501.394107-1.462857zM1799.971929 71.93634l-105.14282 250.331339h79.542829v297.837608h88.063968V225.865428h-31.231989l66.742834-152.502803-98.011394-1.426285z m617.874065 86.308541h285.513041v57.563408h102.290249V148.187741c0-15.835423-11.337139-27.318847-26.989705-27.318847h-164.790798V67.620913H2507.336247v53.247981h-191.743931V217.234574h102.253678V158.281452z"
                          fill="#000000"
                          p-id="4155"></path>
                    <path d="M824.063706 631.588712c143.469663 48.932554 176.127937 50.395411 176.127937 50.39541V161.134022A160.1828 160.1828 0 0 0 839.6797 0.000366H160.6948C72.630831 0.000366 0.146286 71.93634 0.146286 161.134022v683.410042c1.462857 89.234254 72.484546 161.133657 161.974799 161.133657H839.6797c88.063969 0 160.548514-71.935974 160.548514-161.133657v-7.167997s-259.986193-109.348532-390.65586-172.653653c-88.063969 109.348532-201.727928 175.542794-319.634172 175.542794-198.838786 0-267.044476-175.542794-171.885653-290.66961 19.931421-24.429706 55.442266-48.895983 109.421675-63.268549 85.211398-21.577135 220.159921 12.90971 346.587305 54.637695a724.479741 724.479741 0 0 0 56.83198-138.093665H240.237628V362.569379h201.727928V290.633405H197.631929V250.331705h244.297056V148.187741s0-17.261708 17.078851-17.261708h98.011394v119.405672h241.481056v40.3017H556.982658v71.935974h197.449073c-18.468565 77.677687-46.884555 149.613661-83.821685 211.492496 59.647979 23.039992 113.627388 44.617127 153.417088 57.563408z"
                          fill="#00A8F2"
                          p-id="4156"></path>
                    <path d="M272.895903 546.743028c-25.563419 2.85257-72.411403 12.946281-98.011394 35.949701-76.690258 67.657119-31.231989 189.915361 125.001098 189.915361 90.916539 0 180.406793-57.526837 251.428482-151.039946-100.827393-48.932554-186.075362-83.45597-278.418186-74.825116z"
                          fill="#00A8F2"
                          p-id="4157"></path>
                </svg>

            </div>

            <div style="text-align: center; margin-top: 10px; font-weight: 700; font-size: 18px">
                请使用支付宝进行支付

            </div>
           <div style=" font-weight: 300 !important;color: #666;font-size: 16px">
            
         
         
                1.如果你已安装支付宝APP,请点击「使用支付宝APP付款」进行付款；如果未安装，请先
                <div style="color: #00A8F2">点这里下载支付宝APP</div>并完成安装，再点击「使用支付宝APP付款」；

           
  </div>
            <p>
                2.如果您已经完成付款，请点击「已完成付款」按钮，点击后将返回商家。

            </p>

            <div>
                <a id="tzurl" style=" width: calc(100vw - 56px);
            height: 38px;
            background: #00a0e9;
            text-decoration: none;
            outline: 0;
            color: #fff;
            display: block;
            margin: 0 auto;
            margin-top:15px;
            text-align: center;
            line-height: 38px;
            font-size: 20px"
                  :href="orderInfo.jumpUrl">前去授权支付</a>
            </div>

            <div style="margin-top: 10px">
                <a class="btn btn-empty"
                   href="#">已完成付款</a>
            </div>

        </div>

        <div id="loading"
             style="top: 0px; left: 0px; position: fixed; width: 100vw; height: 100vh; background-color: rgba(0, 0, 0, 0.4); display: none; background-position: initial initial; background-repeat: initial initial;">

            <div class="loading"
                 style="text-align: center;">

                <div style="height: 60px; line-height: 60px">

                    <svg class="icon"
                         style="width: 48px; margin-top: 6px; height: 48px; fill: #fff; overflow: hidden; display: inline-block;"
                         viewBox="0 0 1024 1024"
                         version="1.1"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M513.2 72.4c-243 0-440 197-440 440s197 440 440 440 440-197 440-440-197-440-440-440z m0 855.5c-229.5 0-415.5-186-415.5-415.5C97.7 283 283.7 97 513.2 97s415.5 186 415.5 415.5c-0.1 229.4-186.1 415.4-415.5 415.4z m0 0M238.6 638.2v-17.6c0.3-1.7 0.8-3.5 1-5.2 5.2-37 22.4-66.2 55.5-84.9 21.1-12 44.3-16.8 68.3-18.1 36.3-2 72.3 2 107.5 10.6 30.7 7.5 60.8 17.9 91.1 27 1.8 0.5 3.6 1.1 5.3 1.6 12-18.4 35.5-76.8 35.8-88.9H350.6v-25h124.8v-45.1H323v-27.7h152.8v-6.4c0-17.7 0.3-35.5-0.1-53.2-0.2-7.6 2.2-12.9 9.3-15.9h66.5v75.7h162.9v27.8H551.8V438h132.7c-11.8 47.9-29.4 92.9-54.4 136.4 71.1 22.2 141.4 44.1 211.7 66V702c-0.2 1.7-0.6 3.5-0.6 5.2-0.2 11.9-0.3 23.9-0.4 35.8h-1c-1.8-1-3.7-2-5.6-2.9-79.9-35.6-159.8-71.2-239.6-106.9-3.3-1.5-4.9-0.9-7.2 1.7-12.4 13.5-24.6 27.4-37.8 40.1-24.5 23.6-52.5 42.1-84.7 53.7-24.6 8.8-49.9 12.9-76 13.5-29.6 0.7-58.1-3.7-84.8-16.8-27.8-13.6-49-33.6-59.5-63.4-2.9-7.8-4.1-15.9-6-23.8z m295.5-34.6c-1-0.7-1.3-1-1.8-1.2-55.2-27-112.5-46.1-174.8-46.7-23.2-0.2-45.1 4-63.9 18.5-16.1 12.4-27.7 28.1-27.1 49.5 0.8 29 15.9 49.8 41.4 62 35.7 17.1 73.1 17.8 110.4 6.1 48.9-15.4 84.6-48.6 115.8-88.2z"></path>
                    </svg>

                </div>

                <div style="text-align: center; color: #FFF; height: 30px">
                    支付宝

                </div>

                <div style="text-align: center; color: #FFF; height: 30px">

                    <span class="point l-1">&nbsp;</span>
                    <span class="point l-2">&nbsp;</span>
                    <span class="point l-3">&nbsp;</span>

                </div>

            </div>

        </div>

        <div id="box-window"
             style="display: none">

            <div style="box-shadow: 0px 0px 10px 0px #000; width: 230px; margin: 0 auto; margin-top: 15px; padding: 15px;">

                <img id="qrimg"
                     style="width: 100%;">
            </div>

        </div>

        <iframe id="ifr"
                style="display: none"></iframe>

        <div id="mm-text"
             style="position: fixed; top: -100PX"></div>
    </body>
</template>
<script>
let Base64 = require("js-base64").Base64;
let axios = require("axios");
export default {
  name: "otherDjPay",
  data() {
    return {
      orderInfo: {},
      param: {},
    };
  },
  created() {
    var self = this;
    try {
      var param = this.$route.query;
      var data = [];
      for (const i in param) {
        var item = param[i];
        item = Base64.decode(decodeURI(item));
        if (item && item.indexOf("|") >= 0) {
          item = item.split("|")[0];
        }
        data.push(item);
      }
      console.log("Url:"+data[0]);
      console.log("Key:"+data[1]);
      var url = `${data[0]}/Facade/GetMecOrderInfo?orderid=${data[1]}&type=4`;
      axios
        .get(url)
        .then(function(response) { 
          if(response.data.code == 1){
          self.orderInfo = response.data.result;
          }
        })
        .catch(() => {
          alert("请求失败");
        });
    } catch (error) {
      alert("数据异常，请重新尝试");
    }
  },
};
</script>
<style>
p {
  font-weight: 300 !important;
  color: #666;
  font-size: 16px;
}

.btn {
  width: calc(100vw - 56px);
  height: 38px;
  padding: 5px 8px;
  background: #00a0e9;
  text-decoration: none;
  outline: 0;
  color: #fff;
  display: block;
  margin: 0 auto;
  text-align: center;
  line-height: 38px;
  font-size: 20px;
}

.btn-empty {
  width: calc(100vw - 58px);
  background: #fff;
  border: 1px solid #00a0e9;
  color: #333;
}

.btn:active {
  opacity: 0.8;
}

.loading-bg {
  background: rgba(255, 255, 255, 0.9) !important;
}

.boxbg {
  background: rgba(0, 0, 0, 0.3);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}

.box {
  width: 70vw;
  padding: 5px;
  background: #fff;
  position: fixed;
  margin-left: calc(15vw - 5px);
  top: 15vh;
}

.box > .title {
  height: 20px;
  padding: 4px 6px;
  border-bottom: 0.5px solid #eee;
  padding-bottom: 5px;
  line-height: 20px;
}

.box > .content {
  padding: 15px;
  color: #f20;
}

.card {
  margin: 20px;
  border: 0.5px solid #eee;
  border-radius: 3px;
}

.card > .title {
  opacity: 0.8;
  background: #eee;
  padding: 8px;
}

.card > .content {
  margin: 10px;
}

@keyframes p-1 {
  0% {
    background: #fff;
  }

  33% {
    background: #888;
  }

  66% {
    background: #888;
  }

  100% {
    background: #888;
  }
}

@keyframes p-2 {
  0% {
    background: #888;
  }

  33% {
    background: #fff;
  }

  66% {
    background: #888;
  }

  100% {
    background: #888;
  }
}

@keyframes p-3 {
  0% {
    background: #888;
  }

  33% {
    background: #888;
  }

  66% {
    background: #fff;
  }

  100% {
    background: #888;
  }
}

.point.l-1 {
  animation: p-1 1s;
  animation-iteration-count: infinite;
}

.point.l-2 {
  animation: p-2 1s;
  animation-iteration-count: infinite;
}

.point.l-3 {
  animation: p-3 1s;
  animation-iteration-count: infinite;
}

.loading {
  width: 120px;
  height: 120px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  position: fixed;
  left: calc(50vw - 60px);
  top: calc(50vh - 60px);
  z-index: 999;
}

.point {
  border-radius: 50%;
  height: 8px;
  width: 8px;
  background: #666;
  display: inline-block;
  margin-right: 4px;
  margin-left: 4px;
  margin-top: 6.5px;
}
</style>